import api from "./api";

export default {
  create(data) {
    return api.post("/devices", data);
  },
  edit(id, data) {
    return api.put("/devices/" + id, data);
  },
  findAll() {
    return api.get("/devices");
  },
  findOne(id) {
    return api.get("/devices/" + id);
  },
  types() {
    return api.get("/devices/types");
  },
  dispatchCommand(id, command) {
    return api.get(`/devices/${id}/command/${command}`);
  },
  commandHistory() {
    return api.get("/devices/command-history");
  }
};
